import { render, staticRenderFns } from "./WebsiteNavigationList.vue?vue&type=template&id=08ffcffa"
import script from "./WebsiteNavigationList.vue?vue&type=script&lang=ts"
export * from "./WebsiteNavigationList.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../../nuxt-app/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports